import React from "react";
import { FiMonitor } from "react-icons/fi";
import { BRAND_LOGO, BRAND_NAME } from "../../config/app/brandAssets";
import "./MobileDesktopOnlyGate.css";

/**
 * Full-screen block for phone/tablet viewports until responsive mobile ships.
 * Marketing + expectation setting; no sign-in or app shell behind it.
 * Controlled by REACT_APP_MOBILE_DESKTOP_GATE (see config/app/mobileExperience.js).
 */
function MobileDesktopOnlyGate() {
  return (
    <div className="mobile-desktop-gate">
      <div className="mobile-desktop-gate__glow" aria-hidden="true" />

      <div className="mobile-desktop-gate__inner">
        <header className="mobile-desktop-gate__brand">
          <img
            src={BRAND_LOGO.sidebar}
            alt={BRAND_NAME}
            className="mobile-desktop-gate__logo"
          />
        </header>

        <main className="mobile-desktop-gate__content">
          <h1 className="mobile-desktop-gate__headline">
            Built for{" "}
            <span className="mobile-desktop-gate__headline-accent">desktop</span>
          </h1>

          <p className="mobile-desktop-gate__tagline">
            Create stunning product images with AI
          </p>

          <div className="mobile-desktop-gate__card">
            <p className="mobile-desktop-gate__card-lead">
              Open LazyStudio on your laptop or desktop to sign in and start
              editing.
            </p>
            <p className="mobile-desktop-gate__card-note">
              Mobile support is coming soon.
            </p>
          </div>
        </main>

        <footer className="mobile-desktop-gate__footer">
          <span className="mobile-desktop-gate__badge">
            <FiMonitor className="mobile-desktop-gate__badge-icon" aria-hidden="true" />
            Available on desktop
          </span>
        </footer>
      </div>
    </div>
  );
}

export default MobileDesktopOnlyGate;
